// hooks/useDropdownFetch.js
import { useState, useCallback, useRef } from "react";
import { fetchDropdownValues as fetchDropdownValuesAPI } from "../api/fetch";

export const useDropdownValues = () => {
  const [dropdownValueOptions, setDropdownValueOptions] = useState([]);
  const [dropdownValueLoading, setDropdownValueLoading] = useState(false);
  // Keep state for UI updates if needed elsewhere
  
  // Use ref for the mapping to avoid re-renders
  const dropdownValueMappingRef = useRef({});

  const fetchDropdownValues = useCallback(async (dropdownType) => {
    if (!dropdownType) return;

    // Check from ref
    if (dropdownValueMappingRef.current[dropdownType]) {
      setDropdownValueOptions(dropdownValueMappingRef.current[dropdownType]);
      return;
    }

    setDropdownValueLoading(true);

    try {
      let values = await fetchDropdownValuesAPI(dropdownType);
      
      // Update ref
      dropdownValueMappingRef.current[dropdownType] = values;
      
      setDropdownValueOptions(values);
    } catch (error) {
      console.error("Error fetching dropdown values:", error);
      setDropdownValueOptions([]);
    } finally {
      setDropdownValueLoading(false);
    }
  }, []); // No dependencies - function is stable

  const resetDropdownValues = useCallback(() => {
    setDropdownValueOptions([]);
  }, []);

  const clearCacheForType = useCallback((dropdownType) => {
    // Clear from ref
    if (dropdownValueMappingRef.current[dropdownType]) {
      delete dropdownValueMappingRef.current[dropdownType];
    }
    
    // Clear current options if they match the cleared type
    setDropdownValueOptions([]);
  }, []);

  return {
    dropdownValueOptions,
    dropdownValueLoading,
    fetchDropdownValues,
    resetDropdownValues,
    clearCacheForType
  };
};